import axios from "axios";
import route from "ziggy-js";
import { RouteName } from "../Constants/routes";

export const updateFranchiseReadById = async ({ id }) => {
    try {
        await axios.post(route(RouteName.UserScoutUpdateFranchiseRead, { id: id }));

        return {
            success: true,
        };
    } catch (e) {
        console.info("UpdateFranchiseReadById was failed");
        console.error(e, id);
        return {
            success: false,
        };
    }
};
